<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2023-06-16 17:21:12
 * @Description: 
 * @LastEditors: Please set LastEditors
-->
<template>
  <div
    v-if="showMenu"
    class="RightClickMenu position-absolute p-10"
    :style="{ top: `${currentMouseLocation.y}px`, left: `${currentMouseLocation.x}px` }"
  >
    <div class="menu_list p-t-5">
      <div
        class="text-color-white fz-12 p-b-5 tc cur-pointer"
        :class="
          activeItem === item.id
            ? 'active_class'
            : activeMouseItem === item.id
            ? 'active_class'
            : ''
        "
        v-for="item in menuList"
        :key="item.id"
        @click="handleClickMenu(item)"
        @mouseenter="handlerMouseenter(item)"
        @mouseleave="handlerMouseleave(item)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
import { modelTreeObj } from '../js/publicModelMays'
export default {
  name: 'RightClickMenu',
  data() {
    return {
      currentSelectModel: null,
      currentMouseLocation: {
        x: 0,
        y: 0,
      },
      activeItem: -1,
      activeMouseItem: -1,
      menuList: [
        {
          id: 0,
          label: '选择上级',
        },
        {
          id: 1,
          label: '隐藏选中',
        },
        {
          id: 2,
          label: '隐藏未选',
        },
        {
          id: 3,
          label: '居中',
        },
        {
          id: 4,
          label: '透明化选中',
        },
        {
          id: 5,
          label: '透明化未选',
        },
        {
          id: 6,
          label: '状态恢复',
        },
        {
          id: 7,
          label: '复制名称',
        },
      ],
      showMenu: false,
      lastTime: null, // 上一次点击时间
    }
  },
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    tags: {
      type: Array,
      defalut: () => {
        return []
      },
    },
    selectBasicList: {
      type: Array,
      defalut: () => {
        return []
      },
    },
  },
  computed: {
    clientWidth() {
      return document.documentElement.clientWidth
    },
    clientHeight() {
      return document.documentElement.clientHeight
    },
    showModelRightMenu() {
      const systemParams = this.$store.getters.systemParams || []
      const obj = _.find(systemParams, { parameterCode: 'showModelRightMenu' })
      return obj ? obj.parameterValue : 'false'
    },
  },
  async mounted() {
    if (this.showModelRightMenu == 'true') {
      if (!_.isEmpty(this.player)) {
        // this.player.Native.ModelTree.EventBrowseRClick.connect(this.rightClickMsg)
        this.player.Native.ModelTree.EventBrowseLClick.connect(this.watchAnchorPos)
      }
      document.addEventListener('click', (e) => {
        const ePathList = e.path
        const isRouterView = _.findIndex(ePathList, (item) => {
          return item.className === 'RightClickMenu position-absolute p-10'
        })
        if (isRouterView === -1) {
          this.reset(false)
        }
        e.preventDefault()
      })
    }
  },
  methods: {
    async watchAnchorPos(data) {
      if (!this.lastTime) {
        this.lastTime = new Date().getTime()
        return
      }
      let currentTime = new Date().getTime()
      if (currentTime - this.lastTime < 200) {
        // 双击事件
        await this.rightClickMsg(data)
      }
      this.lastTime = currentTime
    },
    /**
     * @description: 右键点击事件
     * @param {*} data
     * @return {*}
     */

    async rightClickMsg(data) {
      if (data && !data.object) {
        this.showMenu = false
        return
      }
      this.currentSelectModel = await this.player.Native.ModelTree.getSelectedItem()
      if (_.isEmpty(this.currentSelectModel)) {
        this.currentSelectModel = data.object
      }
      // 获取可视区域的高度+宽度
      this.currentMouseLocation = {
        x: data.screen[0] + 130 > this.clientWidth ? data.screen[0] - 120 : data.screen[0],
        y: data.screen[1] + 220 > this.clientHeight ? data.screen[1] - 210 : data.screen[1],
      }
      this.showMenu = true
      // 设置点选状态
      if (!this.selectBasicList.includes('system.Pickup')) {
        this.$emit(
          'tagsClick',
          _.find(this.tags, ['val', 'system.Pickup']).val,
          _.find(this.tags, ['val', 'system.Pickup'])
        )
      }
      // 选中当前
      this.player.Native.ModelTree.setSelectItem(this.currentSelectModel.item)
    },
    /**
     * @description: 彩电点击事件
     * @param {*} data
     * @return {*}
     */

    async handleClickMenu(data) {
      this.activeItem = data.id
      const rootItems = await PlayerUtils.call(this.player.Native.ModelTree.getRootItems)
      // 删除地球GIS层
      const rootItemsList = _.map(
        _.filter(rootItems, (item) => {
          return (
            item.itemType === modelTreeObj.ITEM_PR ||
            item.itemType === modelTreeObj.ITEM_NODE ||
            item.ownModel === this.currentSelectModel.ownModel
          )
        }),
        (el) => {
          return el
        }
      )
      switch (data.id) {
        case 0:
          // 选择上级
          if (
            this.currentSelectModel.parentItem &&
            this.currentSelectModel.nodePtr !== this.currentSelectModel.ownModel
          ) {
            this.player.Native.ModelTree.setSelectItem(this.currentSelectModel.parentItem)
            this.currentSelectModel = await this.player.Native.ModelTree.getItemInfo(
              this.currentSelectModel.parentItem
            )
          }
          return
          break
        case 1:
          // 隐藏选中
          this.$emit('setModelVisible', 'system.ToolHideModel', true, this.currentSelectModel)
          break
        case 2:
          // 隐藏未选
          this.$emit('setModelVisible', 'system.ToolShowAll')
          // 显示选中的
          setTimeout(() => {
            this.$emit('setModelVisible', 'system.ToolHideModel', true, this.currentSelectModel)
            setTimeout(() => {
              this.$emit('setModelVisible', 'system.ToolHideModelSpaceSwap')
            }, 200)
          }, 100)
          break
        case 3:
          // 居中
          this.player.Native.Camera.moveToItem(this.currentSelectModel.item, 2)
          break
        case 4:
          // 透明化选中
          this.player.Native.ModelTree.setItemAlpha(this.currentSelectModel.item, 127)
          break
        case 5:
          // 透明化未选
          this.player.Native.ModelTree.setItemAlpha(rootItemsList[0].item, 127)
          this.player.Native.ModelTree.setItemAlpha(this.currentSelectModel.item, 255)
          break
        case 6:
          // 状态恢复setItemAlpha
          this.player.Native.ModelTree.setItemAlpha(rootItemsList[0].item, 255)
          this.$emit('setModelVisible', 'system.ToolShowAll')
          break
        case 7:
          // 复制名称
          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(this.currentSelectModel.name).then(
              function() {
                console.log('成功')
              },
              function() {}
            )
          } else {
            const input = document.createElement('input')
            document.body.appendChild(input)
            input.setAttribute('value', this.currentSelectModel.name)
            input.select()
            if (document.execCommand('copy')) {
              document.execCommand('copy')
            }
            document.body.removeChild(input)
          }
          this.showMenu = false
          break
        default:
          this.showMenu = false
          break
      }
      // 设置点选状态
      if (data.id !== 0) {
        this.reset(true)
      }
    },
    /**
     * @description: 重置点选+菜单
     * @return {*}
     */

    reset(isPickup) {
      this.activeItem = -1
      if (this.selectBasicList.includes('system.Pickup') && isPickup) {
        this.$emit(
          'tagsClick',
          _.find(this.tags, ['val', 'system.Pickup']).val,
          _.find(this.tags, ['val', 'system.Pickup'])
        )
      }
      this.showMenu = false
    },
    // 鼠标移入
    handlerMouseenter(data) {
      this.activeMouseItem = data.id
    },
    // 鼠标移出
    handlerMouseleave(data) {
      this.activeMouseItem = -1
    },
  },
  beforeDestroy() {
    if (!_.isEmpty(this.player) && this.showModelRightMenu == 'true') {
      this.player.Native.ModelTree.EventBrowseRClick.disconnect(this.rightClickMsg)
    }
  },
}
</script>
<style lang="scss">

@import '../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../css/index.scss';
.RightClickMenu {
  border-radius: 4px;
  background-color: rgba(46, 107, 176, 0.5) !important;
  width: 120px;
  height: 210px;
  z-index: 110;
}
.menu_list {
  border-radius: 4px;
  background-color: rgba(24, 41, 72, 0.5) !important;
}
.active_class {
  background-color: rgba(0, 116, 201, 0.4);
  color: #00c0ff !important;
}

</style>
